import { GameService } from './game.service';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  FilePurposeEnum,
  FileTypeEnum,
  IMediaFile,
  IPagedResults,
  SourceTypeEnum,
} from 'lingo2-models';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

export interface IImageThumbnail {
  id?: string;
  url?: string;
  size: string;
  width: number;
  height: number;
  round?: boolean;
  format?: string;
}

export interface IFileType {
  id: string;
  author_id: string;
  filename: string;
  type: FileTypeEnum;
  images?: IImageThumbnail[];
  media?: IMediaFile[];
  storage_file_url?: string; // link to original image (old style)
  isProcessing?: boolean; // show that file is in process now
  parent_file_id?: string; // ID for original user avatar
}

export interface IUploadFileParams {
  target: 'video' | 'audio' | 'image';
  purpose: FilePurposeEnum;
  source: SourceTypeEnum;
  filename: string;
}

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor(
    private http: HttpClient,
    private gameService: GameService,
  ) {}

  public static get isHighDensity() {
    return (
      (window.matchMedia &&
        (window.matchMedia(
          'only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)',
        ).matches ||
          window.matchMedia(
            'only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)',
          ).matches)) ||
      (window.devicePixelRatio && window.devicePixelRatio > 1.3)
    );
  }

  public static get isRetina() {
    return (
      ((window.matchMedia &&
        (window.matchMedia(
          'only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)',
        ).matches ||
          window.matchMedia(
            'only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)',
          ).matches)) ||
        (window.devicePixelRatio && window.devicePixelRatio >= 2)) &&
      /(iPad|iPhone|iPod)/g.test(navigator.userAgent)
    );
  }

  public getOnlineFiles(query: string): Observable<IPagedResults<string[]>> {
    if (!query || query.length === 0) {
      return new Observable<IPagedResults<[]>>();
    }
    const url = `https://${this.gameService.host}/web/files/web-search`;
    const params = new HttpParams().set('q', query);
    return new Observable<IPagedResults<[]>>();

    // return this.http.get<string[]>(url, { params, observe: 'response' }).pipe(
    //   map((response: HttpResponse<string[]>) => {
    //     const content = response.body;
    //     return of({
    //       results: content,
    //       page: response.headers.get('X-Pagination-Page') || 1,
    //       pageSize: response.headers.get('X-Pagination-PageSize') || 1,
    //       total: response.headers.get('X-Pagination-Total') || 1,
    //       totalPages: response.headers.get('X-Pagination-TotalPages') || 1,
    //     });
    //   }),
    //   // catchError(this.handleError),
    // );
  }

  public uploadFileByUrl(uri: string, purpose: FilePurposeEnum, extension?: string): Observable<IFileType> {
    const url = `https://${this.gameService.host}/web/files/file/upload-by-url`;
    const body: Record<string, string | FilePurposeEnum> = {
      url: uri,
      purpose,
    };

    if (extension) {
      body['extension'] = extension;
    }

    return this.http.post<IFileType>(url, body).pipe(
      map((response) => response),
      // catchError(this.handleError),
    );
  }
}
